

































import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import {computed, defineComponent, ref, set} from "@vue/composition-api";
import Alert from "@base/Components/Alert.vue";
import BuilderResultsGroup from "@tool/Builder/sections/BuilderResultsGroup.vue";
import {TableRow} from "@base/base.types";
import useBuilderStore from "@tool/store/useBuilderStore";
import useAppStore from "@tool/store/useAppStore";
import {BuilderUrlInterface} from "@tool/Builder/Builder.types";
import useRequiresUpgradeAlerts from "@tool/Helpers/useRequiresUpgradeAlerts";

export default defineComponent({
    components: {
        ThemeBlock,
        Alert,
        BuilderResultsGroup,
    },
    emits: [
        'shorten',
        'build-similar',
        'saved',
        'shorten'
    ],
    setup(props, {emit}) {

        const {project} = useBuilderStore();

        const fields = [
            {
                key: 'toggle_row',
                label: ''
            },
            {
                key: 'full_url',
                label: 'UTM Url',
                class: 'break-all'
            },
            {
                key: 'actions',
                class: 'actions'
            }
        ];

        const {projectUrls} = useBuilderStore();

        const showAlertInfo = computed(() => {
            return projectUrls.value.length === 0;
        });

        const showAlertWarning = computed(() => {
            return project.value === null && projectUrls.value.length > 0;
        });

        const BuilderStore = useBuilderStore();

        const isLoading = ref(false);

        const onShorten = async (url: BuilderUrlInterface) => {
            if (BuilderStore.project.value === null) {
                BuilderStore.showModalNeedToRegister.value = true;
                return;
            }

            if (!BuilderStore.projectPermissions.value.canManageShorturls) {
                return useRequiresUpgradeAlerts().shorturlsManagement(BuilderStore.project.value!.team_id);
            }

            isLoading.value = true;
            await BuilderStore.shortenUrl(url);
            isLoading.value = false;
        }

        const onBuildSimilar = (url: BuilderUrlInterface) => {
            emit('build-similar', url)
        }


        const onRowClicked = (item: TableRow<BuilderUrlInterface>, index: number, event: Event) => {
            set(item, '_showDetails', item._showDetails ? !item._showDetails : true);
        }


        return {
            fields,
            projectUrls,
            showAlertInfo,
            showAlertWarning,
            isLoading,
            onShorten,
            onBuildSimilar,
            onRowClicked,
        }
    }
});
